import { render, staticRenderFns } from "./people_list.vue?vue&type=template&id=6f6e1e98&scoped=true"
import script from "./people_list.vue?vue&type=script&lang=js"
export * from "./people_list.vue?vue&type=script&lang=js"
import style0 from "./people_list.vue?vue&type=style&index=0&id=6f6e1e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e1e98",
  null
  
)

export default component.exports